import { render, staticRenderFns } from "./BindGift.vue?vue&type=template&id=423b5c19"
import script from "./BindGift.vue?vue&type=script&lang=js"
export * from "./BindGift.vue?vue&type=script&lang=js"
import style0 from "./BindGift.vue?vue&type=style&index=0&id=423b5c19&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports